import React, { useState } from "react"
import { ActionIcon, Button, Container, Tabs, Text, useMantineTheme } from "@mantine/core"

import { Icon } from "@/components"

import { DatasetsTab } from "@/components/TopNavigation/components/SearchPopdown/DatasetsTab/DatasetsTab"
import { RecentsTab } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/RecentsTab"
import { useStyles } from "@/components/TopNavigation/components/SearchPopdown/SearchPopdownStandard.styles"
import { FavoritesTab } from "@/components/TopNavigation/components/SearchPopdown/FavoritesRecentsTabs/FavoritesTab"
import urls from "app/static/frontend/imports/desktopPaths"
import SegueLink from "app/static/frontend/middleware/SegueLink"
import { SearchPopdownStandardProps } from "@/components/TopNavigation/types"

export const SearchPopdownStandard = (props: SearchPopdownStandardProps) => {
    const { classes } = useStyles()
    const theme = useMantineTheme()

    const [activeTab, setActiveTab] = useState("datasets")

    const {
        datasetsOptions,
        gridItemOnClick,
        onCloseSearchPopdown,
        searchPopdownRef,
        searchTips,
        segueToSearch,
        setSearchTerm,
        segueToProfile,
        favorites,
        recents,
        archiveUserAction,
        favoriteUserAction,
        unfavoriteUserAction,
    } = props

    return (
        <Container className={classes.popdown}>
            <span ref={searchPopdownRef}>
                <Text className={classes.headerContainer}>
                    Search
                    {/* @ts-expect-error */}
                    <SegueLink to={urls.searchbar} onClick={onCloseSearchPopdown}>
                        <ActionIcon variant="subtle">
                            <Icon icon="cog" color={theme.colors.gray[7]} />
                        </ActionIcon>
                    </SegueLink>
                </Text>
                <Tabs
                    value={activeTab}
                    onTabChange={setActiveTab}
                    classNames={{
                        panel: classes.panel,
                    }}
                >
                    <Tabs.List className={classes.tabsContainer}>
                        <Tabs.Tab value="recents" className={classes.tabLabel}>
                            <Icon icon="history" />
                            Recents
                        </Tabs.Tab>
                        <Tabs.Tab value="favorites" className={classes.tabLabel}>
                            <Icon icon="star" />
                            Favorites
                        </Tabs.Tab>
                        <Tabs.Tab value="datasets" className={classes.tabLabel}>
                            <Icon icon="layer-group" />
                            Datasets
                        </Tabs.Tab>
                    </Tabs.List>
                    <Tabs.Panel value="recents">
                        <RecentsTab
                            recents={recents}
                            favoriteUserAction={favoriteUserAction}
                            archiveUserAction={archiveUserAction}
                            closeSearchPopdown={onCloseSearchPopdown}
                            segueToSearch={segueToSearch}
                            setSearchTerm={setSearchTerm}
                            segueToProfile={segueToProfile}
                        />
                    </Tabs.Panel>

                    <Tabs.Panel value="favorites">
                        <FavoritesTab
                            favorites={favorites}
                            unfavoriteUserAction={unfavoriteUserAction}
                            closeSearchPopdown={onCloseSearchPopdown}
                            segueToSearch={segueToSearch}
                            setSearchTerm={setSearchTerm}
                            segueToProfile={segueToProfile}
                        />
                    </Tabs.Panel>
                    <Tabs.Panel value="datasets">
                        <DatasetsTab datasetsOptions={datasetsOptions} gridItemOnClick={gridItemOnClick} />
                    </Tabs.Panel>
                </Tabs>
                <div className={classes.footerContainer}>
                    <Button className={classes.searchTips} onClick={searchTips.open}>
                        Advanced search tips
                    </Button>
                    {activeTab === "recents" && (
                        <Button className={classes.searchTips} onClick={props.clearRecents}>
                            Clear recent
                        </Button>
                    )}
                </div>
            </span>
        </Container>
    )
}
